/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const TYPES_MANUFACTURER = {
  Biotronik: [
    {
      id: "BIO-XML",
      hint: "Add .xml file from ICS3000 folder to upload",
      placeholder: "Add .xml file...",
      text: "Browse for XML",
      format: ".xml",
    },
  ],
  Medtronic: [
    {
      id: "MED-PDF",
      hint: "Add .pdf file to upload",
      placeholder: "Add .pdf file...",
      text: "Browse for PDF",
      format: "application/pdf",
    },
  ],
  "St.Jude": [
    {
      id: "STJ-LOG",
      hint: "Add .log file to upload",
      placeholder: "Add .log file...",
      text: "BROWSE FOR LOG",
      format: ".log",
    },
    {
      id: "STJ-PDF",
      hint: "Add .pdf file to upload",
      placeholder: "Add .pdf file...",
      text: "BROWSE FOR PDF",
      format: "application/pdf",
    },
  ],
  BostonScientific: [
    {
      id: "BOS-BNK",
      hint: "Add .bnk file to upload",
      placeholder: "Add .bnk file...",
      text: "BROWSE FOR BNK",
      format: ".bnk",
    },
    {
      id: "BOS-PDF",
      hint: "Add .pdf file to upload",
      placeholder: "Add .pdf file...",
      text: "BROWSE FOR PDF",
      format: "application/pdf",
    },
  ],
};

export const INITIAL_FILE_LIST = {
  Biotronik: [
    {
      type: "text/xml",
      format: "xml",
      file: null,
    },
  ],
  Medtronic: [
    {
      type: "application/pdf",
      format: "pdf",
      file: null,
    },
  ],
  "St.Jude": [
    {
      type: ".log",
      format: "log",
      file: null,
    },
    {
      type: "application/pdf",
      format: "pdf",
      file: null,
    },
  ],
  BostonScientific: [
    {
      type: ".bnk",
      format: "bnk",
      file: null,
    },
    {
      type: "application/pdf",
      format: "pdf",
      file: null,
    },
  ],
};

export const REQUEST_TYPE_PDF = {
  PRELIMINARY: "PRELIMINARY",
  FINAL: "FINAL",
  DEFAULT: "DEFAULT",
};
